/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';
import { CollapsibleNavigationListContext } from './CollapsibleNavigationListContext';

/**
 * Utility hook for consuming the CollapsibleNavigationListContext
 *
 * @returns The value of CollapsibleNavigationListContext provider
 */
function useCollapsibleNavigationListContext() {
  return useContext(CollapsibleNavigationListContext);
}

export { useCollapsibleNavigationListContext };
